import * as React from "react";
import { AccordionArrow, Skeleton } from "@bolteu/kalep-react";
import { cx } from "../../utils/cx";
export function AccordionTableSkeleton({ loadingSkeletonRowCount = 5, paddingStart = 6, paddingEnd = 6, }) {
    const outerContainerStyle = React.useMemo(() => {
        return {
            paddingLeft: getRemFromSpacingSize(paddingStart),
            paddingRight: getRemFromSpacingSize(paddingEnd),
        };
    }, [paddingStart, paddingEnd]);
    return (React.createElement("div", { className: cx("flex flex-col"), style: outerContainerStyle }, [...Array(loadingSkeletonRowCount)].map((_, index) => {
        return (
        // eslint-disable-next-line react/no-array-index-key -- skeleton
        React.createElement("div", { key: index },
            React.createElement("div", { className: cx("py-3 border-solid border-0 border-separator border-b") },
                React.createElement("div", { className: cx("flex items-center justify-between relative") },
                    React.createElement("div", { className: cx("flex-1") },
                        React.createElement(Skeleton, { variant: "text", width: "80%" })),
                    React.createElement("div", { className: cx("shrink-0 w-6 h-6") },
                        React.createElement(AccordionArrow, null))))));
    })));
}
function getRemFromSpacingSize(spacingValue) {
    return `${spacingValue / 4}rem`;
}
